(function ($) {

    $('.contact__tabs').UberAccordion({
        buttonClass: 'tabs__link',

        toggle: false,
        multiple: false,
        preventDefaultButton: true,

        autoExpandButton: function () {
            return this.$buttons.first().attr('href');

        },

        onSelect: function ($button, $target) {
            var $first = $('.contact__accordion-office-target:first', $target);
            if (!$first.hasClass('is-active')) {
                // None active
                var firstHash = '#' + $first.attr('id');
                $target.UberAccordion('toggleActive', firstHash, true);
            } else {
                // Is already active
                var officeCode = $first.attr('id').replace(/^contact__office\-/, '').toUpperCase();
                setOffice(officeCode);
            }
        }

    })

    var $images = $('.contact__bg-map');
    if (!$images.length) {
        return;
    }

    function setOffice(office) {

        var $container = $images.filter('#map__' + office);
        if (!$container.length) {
            return;
        }
        var $image = $('img', $container);
        var src = $container.data('src-lg');
        if (!$image.length && src !== null) {
            var $image = $('<img alt="" src="' + src + '" />');
            $image.on('error', function () {
                console.warn('Contact Module failed to load image source:', src);
            });
            $image.appendTo($container);
        }
        if ($container.length) {
            $images.addClass('hidden');
            $container.removeClass('hidden');
        }
    }

    // Accordions
    var $officeAccordions = $('.contact__accordion-offices');

    $officeAccordions.UberAccordion({
        buttonClass: 'contact__accordion-office-button',
        toggle: true,
        multiple: false,
        autoExpand: true,
        hashChange: false,

        preventDefaultButton: true,

        autoExpandButton: function () {
            return this.$buttons.first().attr('href');

        },

        appliedClasses: {
            button: 'contact__accordion-office-button',
            target: 'contact__accordion-office-target',
            activeButton: 'is-active',
            activeTarget: 'is-active'
        },

        onSelect: function ($button, $target) {
            var officeCode = $target.attr('id').replace(/^contact__office\-/, '').toUpperCase();
            setOffice(officeCode);
        }
    });

    setOffice('CBR');

}(jQuery));

(function ($) {

    function setClosestOffice() {
        var retrievedObject = JSON.parse(localStorage.getItem('closestOffice'));
        $('.aux-nav__item-phone-button a').attr('href', 'tel:' + retrievedObject.data.support.phone);

        var phone_display = retrievedObject.data.support.phone_display;
        $('#geo__header-phone').text(phone_display);
        $('.aux-nav__item-phone-button').css('opacity', '1');

        $('#geo__footer-phone').text(phone_display);
        $('#geo__footer-address').empty()
            .append(retrievedObject.data.streetAddress.join('') + ' ')
            .append(retrievedObject.data.locality + ', ')
            .append('<abbr class="region" title="' + retrievedObject.data.region.title + '">' + retrievedObject.data.region.abbr + '</abbr>' + ' ')
            .append(retrievedObject.data.postalCode + ' ')
            .append(retrievedObject.data.countryName);
    }

    // disable for local dev
    if (window.location.href.indexOf('www.funnelback.com') > -1) {
        if (localStorage.getItem('closestOffice') === null || ((Date.now() - localStorage.getItem('closestOfficeTimestamp')) / 1000) >= 86400) {
            $.ajax({
                url: 'https://www.funnelback.com/api/closest-office',
                type: 'GET',
                dataType: 'json',
                success: function (result) {
                    var closestOffice = result;
                    localStorage.setItem('closestOffice', JSON.stringify(closestOffice));
                    localStorage.setItem('closestOfficeTimestamp', Date.now());

                    setClosestOffice();

                }
            });

        } else {
            setClosestOffice();
        };
    };

}(jQuery));